export class KlipyApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async searchGifs(params) {
        const qs = new URLSearchParams({ q: params.q });
        if (params.page)
            qs.set('page', String(params.page));
        if (params.per_page)
            qs.set('per_page', String(params.per_page));
        if (params.conversationId)
            qs.set('conversation_id', params.conversationId);
        return this.client.get(`/api/klipy/gifs/search?${qs}`);
    }
    async trendingGifs(params) {
        const qs = new URLSearchParams();
        if (params?.page)
            qs.set('page', String(params.page));
        if (params?.per_page)
            qs.set('per_page', String(params.per_page));
        if (params?.conversationId)
            qs.set('conversation_id', params.conversationId);
        const query = qs.toString();
        return this.client.get(`/api/klipy/gifs/trending${query ? `?${query}` : ''}`);
    }
    async searchStickers(params) {
        const qs = new URLSearchParams({ q: params.q });
        if (params.page)
            qs.set('page', String(params.page));
        if (params.per_page)
            qs.set('per_page', String(params.per_page));
        if (params.conversationId)
            qs.set('conversation_id', params.conversationId);
        return this.client.get(`/api/klipy/stickers/search?${qs}`);
    }
    async trendingStickers(params) {
        const qs = new URLSearchParams();
        if (params?.page)
            qs.set('page', String(params.page));
        if (params?.per_page)
            qs.set('per_page', String(params.per_page));
        if (params?.conversationId)
            qs.set('conversation_id', params.conversationId);
        const query = qs.toString();
        return this.client.get(`/api/klipy/stickers/trending${query ? `?${query}` : ''}`);
    }
    async share(params) {
        return this.client.post('/api/klipy/share', params);
    }
}
//# sourceMappingURL=klipy-api.js.map